<template>
    <div
        class="md-team template6-list"
        v-if="allTotal > 0"
        :style="{ 
            marginBottom, 
            paddingTop,
            backgroundColor: bgColor
        }"
    >
        <module-box
            class="template6-list-wrap"
            :fullColumn="fullColumn || isMobileSize"
            :noPadding="true"
            :noMargin="true"
        >
            <div class="module-header">
                <div class="mg-title" v-html="formatFontSize(fmtTitle, '--mg-title-size')"></div>
                <div
                    class="swiper-button"
                    v-if="!isMobileSize && agents.length > 4"
                >
                    <span class="button-prev">
                        <i class="iconfont icon-arrow-up prev-el"></i>
                    </span>
                    <span class="button-next">
                        <i class="iconfont icon-arrow-up next-el"></i>
                    </span>
                </div>
            </div>
            <swiper class="agent-swiper" v-bind="options" v-if="agents.length">
                <slide
                    v-for="(item, index) in agents"
                    :key="index + item.detailUrl"
                >
                    <div
                        class="agent-item"
                        @click="gotoLink(item.detailUrl)"
                    >
                        <AgentCard :agent="item" />
                    </div>
                </slide>
            </swiper>
        </module-box>
    </div>
</template>

<script>
import common from '../index';
import { brokerListSpacing } from '../../defaultSpacing';
import AgentCard from './agent-card';
import carousel from '../carousel';
export default {
    mixins: [common, carousel],
    data: function() {
        return {
            ...brokerListSpacing,
            rows: 4,
            autoplay: true,
            autoplayDelay: 8,
            slidesPerGroupType: 'single',
            slidesPerView: 4,
            mobileSlidesPerView: 2,
            loop: true
        };
    },
    components: {
        AgentCard
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';

.md-team.template6-list {
    width: 100%;

    .template6-list-wrap {
        position: relative;
        padding-top: 10px;
        padding-bottom: 50px;

        .module-header {
            display: flex;
            justify-content: space-between;

            .swiper-button {
                flex-shrink: 0;
                width: 98.5px;
                height: 14px;
                display: flex;
                justify-content: space-between;
                z-index: var(--level-low);

                .button-prev {
                    color: #fff;
                    transform: rotate(-90deg);
                    cursor: pointer;
                }

                .button-next {
                    color: #fff;
                    transform: rotate(90deg);
                    cursor: pointer;
                }

                .iconfont {
                    font-size: 22px;
                }
            }
        }

        .mg-title {
            color: #fff;
            font-size: 24px;
            line-height: 24px;
            font-family: var(--mg-title-font);
        }

        .agent-swiper {
            width: 100%;
            overflow: hidden;

            .swiper-wrapper {
                display: flex;
                justify-content: space-between;

                .swiper-slide {
                    &:last-child {
                        margin-right: 0;
                    }

                    .agent-item {
                        width: 235px;
                    }
                }
            }
        }

        @include media-600 {
            .module-header {
                padding: 5px 0 25px 15px;

                .mg-title {
                    padding-right: 20px;
                    font-size: 16px;
                }
            }
        }
    }
}
</style>
